import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { HrmBankAccountFormComponent } from "../hrm-bank-account-form/hrm-bank-account-form.component";

@Component({
  selector: "ngx-hrm-bank-account-list",
  templateUrl: "./hrm-bank-account-list.component.html",
  styleUrls: ["./hrm-bank-account-list.component.scss"],
})
export class HrmBankAccountListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  filterInfo: NameValue[] = [];
  editingName: { name: string };
  constructor() {
    super();
    this.inputEditorform = HrmBankAccountFormComponent;
  }
  ngOnInit() {
    this.apiName = "HrmBankAccount/GetHrmBankAccountList";
    this.areaName = "Payroll";
    this.label = "ارتباط حساب کارکنان به محل خدمت";
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      if (
        this.accountService.authService.getHrmPayCurentYearMonth().CurentYear &&
        this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth
      ) {
        this.filterInfo.push({ Name: "IssueYear", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear, Operator: "lte" });
        this.filterInfo.push({ Name: "IssueMonth", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth, Operator: "lte" });
      }
    }
  }
}
